<salonmonster-load-mask *ngIf="isLoading"></salonmonster-load-mask>
<mat-tab-group [(selectedIndex)]="tabIndex" *ngIf="!isLoading" class="sm-login-tabs">
  <mat-tab [label]="'AUTH.LOG_IN' | translate">
    <div class='login-container'>

      <!-- Generic error card -->
      <mat-card *ngIf="loginError" class='smr-error-card'>
        <mat-card-content>
          {{ 'AUTH.LOGIN_ERROR' | translate }}
        </mat-card-content>
      </mat-card>

      <!-- ========== EMAIL ENTRY VIEW ========== -->
      <ng-container *ngIf="viewState === 'emailEntry'">
        <form [formGroup]='clientForm' (ngSubmit)="authMode === 'magic_code' ? onSendCode($event) : onPasswordButton($event)">

          <!-- Heading -->
          <h2>{{ 'AUTH.LOG_IN' | translate }}</h2>
          <p *ngIf="authMode === 'magic_code'" class="smc-subheading">{{ 'AUTH.ENTER_EMAIL_FOR_CODE' | translate }}</p>

          <!-- Email field -->
          <mat-form-field sm-full-width appearance="outline">
            <mat-label>{{ 'AUTH.YOUR_EMAIL' | translate }}</mat-label>
            <input matInput [placeholder]="'AUTH.YOUR_EMAIL' | translate" type="text" name='email' formControlName="email" />
          </mat-form-field>

          <div *ngIf='!email.valid && submitted' class='sm-validation-error'>
            <p *ngIf="email.hasError('required')">
              {{ 'AUTH.EMAIL_REQUIRED' | translate }}
            </p>
            <p *ngIf="email.hasError('validateEmail')">
              {{ 'AUTH.EMAIL_INVALID' | translate }}
            </p>
          </div>

          <!-- Rate limit error on email entry -->
          <mat-card *ngIf="codeError === 'rate_limited'" class='smr-error-card'>
            <mat-card-content>
              {{ 'AUTH.RATE_LIMITED' | translate:{ minutes: remainingAttempts } }}
            </mat-card-content>
          </mat-card>

          <!-- Reusable "no account on file" prompt, shown above whichever magic-code button is visible -->
          <ng-template #unknownEmailPrompt>
            <div *ngIf="codeError === 'unknown_email'" class="smc-unknown-email">
              <p>{{ (allowSignUp ? 'AUTH.UNKNOWN_EMAIL_PROMPT' : 'AUTH.UNKNOWN_EMAIL_NO_SIGNUP') | translate }}</p>
              <button mat-button type="button" class="smc-link" *ngIf="allowSignUp" (click)="goToCreateAccount()">
                {{ 'AUTH.CREATE_ACCOUNT_LINK' | translate }}
              </button>
            </div>
          </ng-template>

          <!-- Send magic code button (primary, on top) — magic-code mode, or 'both' mode before the user opts into password login -->
          <ng-container *ngIf="authMode === 'magic_code' || (authMode === 'both' && !passwordRevealed)">
            <ng-container *ngTemplateOutlet="unknownEmailPrompt"></ng-container>
          </ng-container>
          <div style='text-align: center;' *ngIf="authMode === 'magic_code' || (authMode === 'both' && !passwordRevealed)">
            <button mat-raised-button primaryButton sm-full-width type="button"
              (click)="onSwitchToCode()">
              {{ 'AUTH.SEND_MAGIC_CODE' | translate }}
            </button>
          </div>

          <!-- Password field — always shown in password mode; in 'both' mode only after the client opts in -->
          <ng-container *ngIf="authMode === 'password' || (authMode === 'both' && passwordRevealed)">
            <br/>
            <mat-form-field sm-full-width appearance="outline">
              <mat-label>{{ authMode === 'both' ? ('AUTH.OR_ENTER_PASSWORD' | translate) : ('AUTH.YOUR_PASSWORD' | translate) }}</mat-label>
              <input matInput #passwordInput type="password" name='password' formControlName="password" />
              <mat-hint *ngIf="authMode !== 'both'">{{ 'AUTH.PASSWORD_HINT' | translate }}</mat-hint>
            </mat-form-field>
            <br />
          </ng-container>

          <!-- Log in with password button — shown in password & both modes; in 'both' the first tap reveals the field above -->
          <div style='text-align: center;' *ngIf="authMode !== 'magic_code'">
            <br *ngIf="authMode === 'both' && !passwordRevealed" />
            <!-- Primary variant: 'both' mode once the password field is revealed -->
            <button *ngIf="authMode === 'both' && passwordRevealed"
              mat-raised-button primaryButton sm-full-width type="submit"
              (click)="onPasswordButton($event)">
              {{ 'AUTH.LOGIN_WITH_PASSWORD' | translate }}
            </button>
            <!-- Default/secondary variant: 'both' mode collapsed, or password-only mode -->
            <button *ngIf="!(authMode === 'both' && passwordRevealed)"
              mat-raised-button sm-full-width type="submit"
              [class.smc-button-secondary]="authMode === 'both'"
              (click)="onPasswordButton($event)">
              {{ authMode === 'both' ? ('AUTH.LOGIN_WITH_PASSWORD' | translate) : ('AUTH.LOG_IN' | translate) }}
            </button>
          </div>

          <!-- Send magic code button (demoted to normal, below) — 'both' mode once password login is chosen -->
          <ng-container *ngIf="authMode === 'both' && passwordRevealed">
            <ng-container *ngTemplateOutlet="unknownEmailPrompt"></ng-container>
          </ng-container>
          <div style='text-align: center;' *ngIf="authMode === 'both' && passwordRevealed">
            <br/>
            <button mat-raised-button sm-full-width type="button"
              class="smc-button-secondary"
              (click)="onSwitchToCode()">
              {{ 'AUTH.SEND_MAGIC_CODE' | translate }}
            </button>
          </div>

          <!-- Send code button (primary) for magic-code-only mode -->
          <div style='text-align: center;' *ngIf="authMode === 'magic_code'">
            <br/>
            <button mat-raised-button primaryButton sm-full-width type="submit"
              (click)="onSendCode($event)">
              {{ 'AUTH.SEND_CODE' | translate }}
            </button>
          </div>

          <br/>

          <div style='text-align: center;'>
            <!-- Sign up button -->
            <button mat-button sm-full-width *ngIf="showSignupTab()"
              class='smc-full-width smc-button-secondary'
              (click)="showSignup()">
              {{ 'AUTH.NEW_HERE_SIGNUP' | translate }}
            </button>
            <br /><br />

            <!-- Forgot password (hidden in magic-code-only mode) -->
            <button mat-button class='smc-full-width' *ngIf="showForgotPassword()"
              (click)="forgotPassword()">
              {{ 'AUTH.FORGOT_PASSWORD' | translate }}
            </button>
            <br /><br />

            <!-- Staff login -->
            <button mat-button class='smc-full-width' (click)="staffLogin()">
              {{ 'AUTH.STAFF_LOGIN' | translate }}
            </button>
            <br/><br/><br/>
          </div>
        </form>
      </ng-container>

      <!-- ========== NEW CLIENT INFO VIEW (R7) ========== -->
      <ng-container *ngIf="viewState === 'newClientInfo'">
        <h2>{{ 'AUTH.NEW_CLIENT_INFO' | translate }}</h2>

        <mat-form-field sm-full-width appearance="outline">
          <mat-label>{{ 'AUTH.YOUR_EMAIL' | translate }} *</mat-label>
          <input matInput [formControl]="email" type="text" />
        </mat-form-field>
        <div *ngIf='!email.valid && newClientSubmitted' class='sm-validation-error'>
          <p *ngIf="email.hasError('required')">{{ 'AUTH.EMAIL_REQUIRED' | translate }}</p>
          <p *ngIf="email.hasError('validateEmail')">{{ 'AUTH.EMAIL_INVALID' | translate }}</p>
        </div>

        <mat-form-field sm-full-width appearance="outline">
          <mat-label>{{ 'AUTH.FIRST_NAME' | translate }}</mat-label>
          <input matInput [formControl]="firstName" type="text" />
        </mat-form-field>
        <div *ngIf='!firstName.valid && newClientSubmitted' class='sm-validation-error'>
          <p>{{ 'AUTH.FIRST_NAME' | translate }} {{ 'AUTH.EMAIL_REQUIRED' | translate }}</p>
        </div>

        <mat-form-field sm-full-width appearance="outline">
          <mat-label>{{ 'AUTH.LAST_NAME' | translate }}</mat-label>
          <input matInput [formControl]="lastName" type="text" />
        </mat-form-field>
        <div *ngIf='!lastName.valid && newClientSubmitted' class='sm-validation-error'>
          <p>{{ 'AUTH.LAST_NAME' | translate }} {{ 'AUTH.EMAIL_REQUIRED' | translate }}</p>
        </div>

        <mat-form-field sm-full-width appearance="outline">
          <mat-label>{{ 'AUTH.PHONE' | translate }} *</mat-label>
          <input matInput [formControl]="clientPhone" type="tel" inputmode="tel" />
        </mat-form-field>
        <div *ngIf='!clientPhone.valid && newClientSubmitted' class='sm-validation-error'>
          <p *ngIf="clientPhone.hasError('required')">{{ 'AUTH.PHONE' | translate }} {{ 'AUTH.EMAIL_REQUIRED' | translate }}</p>
          <p *ngIf="clientPhone.hasError('validatePhone')">{{ 'AUTH.PHONE' | translate }} {{ 'AUTH.EMAIL_INVALID' | translate }}</p>
        </div>

        <br/>

        <div style='text-align: center;'>
          <button mat-raised-button primaryButton sm-full-width (click)="onSubmitNewClientInfo($event)">
            {{ 'AUTH.SEND_MAGIC_CODE' | translate }}
          </button>
          <p class="smc-required-legend">{{ 'AUTH.REQUIRED_LEGEND' | translate }}</p>
        </div>
      </ng-container>

      <!-- ========== CODE ENTRY VIEW ========== -->
      <ng-container *ngIf="viewState === 'codeEntry'">
        <h2>{{ 'AUTH.ENTER_CODE' | translate }}</h2>
        <p class="smc-subheading">{{ 'AUTH.CODE_SENT_TO' | translate:{ email: codeEmail } }}</p>

        <!-- Code error messages -->
        <mat-card *ngIf="codeError === 'invalid_code'" class='smr-error-card'>
          <mat-card-content>
            {{ 'AUTH.CODE_INCORRECT' | translate:{ remaining: remainingAttempts } }}
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="codeError === 'code_expired'" class='smr-error-card'>
          <mat-card-content>
            {{ 'AUTH.CODE_EXPIRED' | translate }}
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="codeError === 'code_invalidated'" class='smr-error-card'>
          <mat-card-content>
            {{ 'AUTH.CODE_INVALIDATED' | translate }}
          </mat-card-content>
        </mat-card>
        <mat-card *ngIf="codeError === 'rate_limited'" class='smr-error-card'>
          <mat-card-content>
            {{ 'AUTH.RATE_LIMITED' | translate:{ minutes: remainingAttempts } }}
          </mat-card-content>
        </mat-card>

        <!-- Code input -->
        <mat-form-field sm-full-width appearance="outline" *ngIf="codeError !== 'code_invalidated'">
          <mat-label>{{ 'AUTH.ENTER_CODE' | translate }}</mat-label>
          <input matInput [formControl]="otpCode" type="text"
            maxlength="6" inputmode="numeric" pattern="[0-9]*"
            autocomplete="one-time-code" />
        </mat-form-field>

        <div *ngIf='!otpCode.valid && codeSubmitted && codeError !== "code_invalidated"' class='sm-validation-error'>
          <p>{{ 'AUTH.EMAIL_REQUIRED' | translate }}</p>
        </div>

        <br/>

        <div style='text-align: center;'>
          <!-- Verify button -->
          <button mat-raised-button primaryButton sm-full-width (click)="onVerifyCode($event)"
            *ngIf="codeError !== 'code_invalidated'">
            {{ 'AUTH.LOG_IN' | translate }}
          </button>

          <br /><br />

          <!-- Resend code -->
          <button mat-button class='smc-full-width'
            *ngIf="codeError !== 'code_invalidated'"
            [disabled]="resendCooldown > 0"
            (click)="onResendCode()">
            <span *ngIf="resendCooldown > 0">{{ 'AUTH.RESEND_CODE_IN' | translate:{ seconds: resendCooldown } }}</span>
            <span *ngIf="resendCooldown <= 0">{{ 'AUTH.RESEND_CODE' | translate }}</span>
          </button>

          <!-- Request new code (after invalidation) -->
          <button mat-raised-button primaryButton sm-full-width
            *ngIf="codeError === 'code_invalidated'"
            (click)="onResendCode()">
            {{ 'AUTH.RESEND_CODE' | translate }}
          </button>

          <br /><br />

          <!-- Wrong email? -->
          <button mat-button class='smc-full-width' (click)="onBackToEmail()">
            {{ 'AUTH.WRONG_EMAIL' | translate }}
          </button>

          <!-- Use password instead (both mode only) -->
          <button mat-button class='smc-full-width' *ngIf="authMode === 'both'"
            (click)="onBackToEmail()">
            {{ 'AUTH.USE_PASSWORD_INSTEAD' | translate }}
          </button>

          <br/><br/>
        </div>
      </ng-container>

    </div>
  </mat-tab>
  <mat-tab [label]="'AUTH.SIGN_UP' | translate" *ngIf="showSignupTab()">
    <div class='login-container'>
      <h2>{{ 'AUTH.SIGN_UP' | translate }}</h2>
      <client-sign-up (viewLogIn)="showLogin()" (signUp)="onSignUp($event)"></client-sign-up>
    </div>
  </mat-tab>
</mat-tab-group>
